import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import React from 'react'
import { Tooltip } from 'react-tooltip'

const PopupFooter = ({ onClose, onConfirm, closeLabel = "Cancel", confirmLabel = "Save", disabled = false ,tooltip}) => {
    return (
        <div className="flex flex-wrap items-center justify-end gap-2 mt-5">
            <CustomButtonNew label={closeLabel} variant="outline" onClick={onClose} />
            {!!onConfirm && <CustomButtonNew onClick={onConfirm} label={confirmLabel} disabled={disabled} data-tooltip-id={`${tooltip}-tooltip`} data-tooltip-content={tooltip} />}
            {!!tooltip && <Tooltip id={`${tooltip}-tooltip`} />}
        </div>
    )
}

export default PopupFooter